<template>
  <!-- 有默认插槽：flex 排布；开启国际化时显示按钮（依赖 store app.inputI18n） -->
  <div v-if="hasControlSlot" class="locale-field-inline"
       :class="[
      `locale-field-inline--${inputType}`,
      { 'locale-field-inline--no-i18n': !inputI18n }
    ]"
  >
    <div class="locale-field-inline__control">
      <slot />
    </div>
    <span v-show="inputI18n" class="locale-field-inline__suffix">
      <a-button :disabled="!fieldValue" :class="hasLocale ? 'i18n-ok' : 'i18n-missing'" @click="openLocale">
        国际化
      </a-button>
    </span>
    <locale-field v-show="inputI18n" ref="localeField" @localeChange="onLocaleChange" />
  </div>
  <!-- 无插槽：仅按钮（如 a-input 的 slot="suffix"） -->
  <span v-else-if="inputI18n" class="locale-field-button-wrapper">
    <a-button :disabled="!fieldValue" :class="hasLocale ? 'i18n-ok' : 'i18n-missing'" @click="openLocale">
      国际化
    </a-button>
    <locale-field ref="localeField" @localeChange="onLocaleChange" />
  </span>
</template>

<script>
import LocaleField from '@/components/locale/LocaleField.vue'
import { baseMixin } from '@/store/app-mixin'

export default {
  name: 'LocaleFieldButton',
  components: { LocaleField },
  mixins: [baseMixin],
  props: {
    value: {
      type: Array,
      required: false
    },
    tableName: {
      type: String,
      required: true
    },
    inputType: {
      type: String,
      default: 'input'
    },
    tableField: {
      type: String,
      required: true
    },
    fieldValue: {
      type: String,
      default: ''
    }
  },
  computed: {
    hasLocale() {
      return Array.isArray(this.value) && this.value.length > 0
    },
    hasControlSlot() {
      const d = this.$slots.default
      if (!d || !d.length) {
        return false
      }
      return d.some((vn) => vn.tag || (vn.text && String(vn.text).trim()))
    }
  },
  methods: {
    openLocale() {
      const existingList = Array.isArray(this.value) ? this.value : []
      this.$refs.localeField &&
        this.$refs.localeField.showLocaleField(
          this.inputType,
          this.tableName,
          this.tableField,
          this.fieldValue,
          existingList
        )
    },
    onLocaleChange(list) {
      this.$emit('input', Array.isArray(list) ? list : [])
    }
  }
}
</script>

<style>
.i18n-ok {
  background-color: #52c41a;
  border-color: #52c41a;
  color: #fff;
}
.i18n-missing {
  background-color: #ff4d4f;
  border-color: #ff4d4f;
  color: #fff;
}
.ant-input-suffix-button {
  right: -2px;
  position: absolute !important;
}
.locale-field-inline {
  display: flex;
  flex-flow: row nowrap;
  align-items: flex-start;
  gap: 8px;
  width: 100%;
  max-width: 100%;
}
.locale-field-inline__control {
  flex: 1 1 auto;
  min-width: 0;
}
.locale-field-inline__suffix {
  flex: 0 0 auto;
  line-height: 1;
  padding-top: 4px;
}
.locale-field-inline--editor .locale-field-inline__suffix {
  padding-top: 10px;
}
</style>
